"use client";

import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import {
  openSecurityCampaign,
  SECURITY_CAMPAIGN_ENABLED,
} from "./securityCampaign";

export default function SecurityTipBanner() {
  const { user } = useAuth();

  if (!SECURITY_CAMPAIGN_ENABLED || !user) return null;

  return (
    <aside className="flex flex-col gap-4 rounded-2xl border border-primary/15 bg-primary/[0.04] p-4 sm:flex-row sm:items-center sm:justify-between dark:border-dark-primary/20 dark:bg-dark-primary/[0.06]">
      <div className="flex min-w-0 items-start gap-3">
        <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary dark:bg-dark-primary/10 dark:text-dark-primary">
          <ShieldCheck className="h-5 w-5" aria-hidden="true" />
        </div>
        <div>
          <p className="font-semibold text-text-default dark:text-dark-text-default">
            Protege tus accesos
          </p>
          <p className="mt-0.5 text-sm leading-5 text-text-muted dark:text-dark-text-muted">
            Tu usuario y contraseña son personales. No los compartas ni los guardes en equipos públicos o compartidos.
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={openSecurityCampaign}
        className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold text-primary transition hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-primary/30 dark:text-dark-primary dark:hover:bg-dark-primary/10"
      >
        Ver consejos
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </button>
    </aside>
  );
}
